import * as React from 'react';
import { Button, useDeviceType } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';

import { NewAnswerFooter } from '../../components/NewAnswer/parts/NewAnswerFooter';
import { addAnswerActions } from '../../actions/newAnswer/addAnswerActions';
import { getIsNextStepAvailable } from '../../selectors/newAnswer';
import { getIsReviewTab } from '../../selectors/tabs';
import { addQuestionAnswerActions } from '../../actions/newAnswer/addQuestionAnswerActions';
import { TAnswerTarget } from '../../types/answers';

interface INewAnswerFooterContainerProps {
  reviewId: string;
  type: TAnswerTarget;
}

export const NewAnswerFooterContainer = ({ reviewId, type }: INewAnswerFooterContainerProps) => {
  const dispatch = useDispatch();
  const isNextStepAvailable = useSelector(getIsNextStepAvailable);
  const isReview = useSelector(getIsReviewTab);

  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  const onClick = () => {
    if (isReview) {
      dispatch(addAnswerActions({ reviewId, type }));
    } else {
      dispatch(addQuestionAnswerActions({ questionId: reviewId, type }));
    }
  };

  return (
    <NewAnswerFooter
      next={
        <Button
          disabled={isReview && !isNextStepAvailable}
          data-testid="publish"
          onClick={onClick}
          fullWidth={isMobile}
          size={isMobile ? 'M' : 'XS'}
        >
          Опубликовать
        </Button>
      }
    />
  );
};
